import { Address } from 'viem';

export const GGTokenAddress: Address = '0xef417FCE1883c6653E7dC6AF7c6F85CCDE84Aa09';
